import { create } from "zustand";
import { NotificationActions, NotificationState } from "@interfaces";

export const useNotificationStore = create<
  NotificationState & NotificationActions
>()((set, get) => ({
  notifications: [],

  setNotifications: (notifications) => {
    set(() => ({ notifications }));
  },

  markAsRead: (id) => {
    const updated = get().notifications.map((notification) =>
      notification.id === id ? { ...notification, read: true } : notification
    );
    set(() => ({ notifications: updated }));
  },

  markAllAsRead: () => {
    const updated = get().notifications.map((notification) => ({
      ...notification,
      read: true,
    }));
    set(() => ({ notifications: updated }));
  },

  clearAll: () => {
    set(() => ({ notifications: [] }));
  },
}));
